export const SERVICE_EMAIL_CONFIRMATION = "SERVICE_EMAIL_CONFIRMATION";
export const SERVICE_EMAIL_CONFIRMATION_SUCCESS = "SERVICE_EMAIL_CONFIRMATION_SUCCESS";
export const SERVICE_EMAIL_CONFIRMATION_FAIL = "SERVICE_EMAIL_CONFIRMATION_FAIL";
